import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
}
export function Card({
  children,
  className = ''
}: CardProps) {
  return <div className={`bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden ${className}`} data-id="element-86">
      {children}
    </div>;
}
export function CardHeader({
  children,
  className = ''
}: CardProps) {
  return <div className={`px-6 py-4 border-b border-slate-100 ${className}`} data-id="element-87">
      {children}
    </div>;
}
export function CardContent({
  children,
  className = ''
}: CardProps) {
  return <div className={`p-6 ${className}`} data-id="element-88">{children}</div>;
}
export function CardFooter({
  children,
  className = ''
}: CardProps) {
  return <div className={`px-6 py-4 bg-slate-50 border-t border-slate-100 ${className}`} data-id="element-89">
      {children}
    </div>;
}